import VueI18n from 'vue-i18n'

//i18n filter比較特別，需要注入vueI18n實例
export function ParaDisplay($i18n: VueI18n) {
	return (value: any, paramesters: Array<any>) => {
		if (!Array.isArray(paramesters)) {
			return value
		}

		let result = paramesters.find(parameter => parameter.PhsiName == value)
		if (!result) {
			return value
		}
		if ($i18n.locale === 'en-us') {
			return result.DispNameInEnglish
		}
		return result.DispName
	}
}

export function I18nColumn($i18n: VueI18n) {
	return (data: any, columnName: string) => {
		if (!data) {
			return data
		}

		if ($i18n.locale && $i18n.locale.includes('en-us')) {
			return (
				data['English' + columnName] ||
				data[columnName + 'InEnglish'] ||
				data[columnName + '_in_english'] ||
				data[columnName + '_en'] ||
				data[columnName + 'En'] ||
				data[columnName.replace('Name', 'Ename')] ||
				data[columnName.replace('name', 'ename')] ||
				data[columnName]
			)
		}
		return data[columnName]
	}
}
